// Saved 'light' and 'dark' render as 'theme'.
export const LINK_IN_BIO_LOOKS = ['theme', 'brand', 'light', 'dark'] as const;
export const LINK_IN_BIO_ALIGNS = ['left', 'center', 'right'] as const;
export const LINK_IN_BIO_SOCIAL_PLATFORMS = [
  'instagram',
  'facebook',
  'tiktok',
  'youtube',
  'x',
  'linkedin',
  'whatsapp',
  'email',
  'website',
] as const;
export const LINK_IN_BIO_SOCIAL_BRAND_NAMES: Partial<
  Record<(typeof LINK_IN_BIO_SOCIAL_PLATFORMS)[number], string>
> = {
  instagram: 'Instagram',
  facebook: 'Facebook',
  tiktok: 'TikTok',
  youtube: 'YouTube',
  x: 'X',
  linkedin: 'LinkedIn',
  whatsapp: 'WhatsApp',
};
export const LINK_IN_BIO_BLOCK_TYPES = [
  'page',
  'events',
  'link',
  'heading',
  'portal',
  'email',
] as const;
export const LINK_IN_BIO_BLOCK_STYLES = ['button', 'card'] as const;
export const LINK_IN_BIO_LIMITS = {
  title: 80,
  bio: 300,
  socials: 12,
  blocks: 100,
  blockTitle: 100,
  url: 2048,
  eventsMin: 1,
  eventsMax: 20,
  eventsDefault: 5,
} as const;

export type LinkInBioLook = (typeof LINK_IN_BIO_LOOKS)[number];
export type LinkInBioAlign = (typeof LINK_IN_BIO_ALIGNS)[number];
export type LinkInBioSocialPlatform = (typeof LINK_IN_BIO_SOCIAL_PLATFORMS)[number];
export type LinkInBioBlockType = (typeof LINK_IN_BIO_BLOCK_TYPES)[number];
export type LinkInBioBlockStyle = (typeof LINK_IN_BIO_BLOCK_STYLES)[number];

export type LinkInBioMedia = {
  file?: string | null;
  url: string;
  name?: string | null;
  size?: number | null;
  width?: number | null;
  height?: number | null;
};

export type LinkInBioBlock = {
  id?: string | null;
  type: LinkInBioBlockType;
  title?: string | null;
  url?: string | null;
  page?: string | null;
  limit?: number | null;
  thumbnail?: LinkInBioMedia | null;
  icon?: string | null;
  showFrom?: string | null;
  showUntil?: string | null;
  style: LinkInBioBlockStyle;
  hidden: boolean;
};

export type LinkInBioSocial = { platform: LinkInBioSocialPlatform; url: string };

export type LinkInBio = {
  published: boolean;
  title?: string | null;
  bio?: string | null;
  avatar?: LinkInBioMedia | null;
  look: LinkInBioLook;
  /** Unset uses the store's default theme. */
  theme?: string | null;
  align?: LinkInBioAlign;
  /** Unset follows the store's branding setting. */
  showCheckoutPageBranding?: boolean | null;
  socials: LinkInBioSocial[];
  blocks: LinkInBioBlock[];
};

export type LinkInBioPageType = 'checkout' | 'event' | 'form';

export type LinkInBioEventSummary = {
  startDate: string | null;
  endDate: string | null;
  timezone: string | null;
  status: 'active' | 'sold_out' | 'canceled' | null;
  location: string | null;
  type: 'in_person' | 'virtual' | 'hybrid' | null;
};

export type LinkInBioPageSummary = {
  id: string;
  type: LinkInBioPageType;
  slug: string;
  status: 'published' | 'draft' | 'archived';
  testmode: boolean;
  title: string;
  imageUrl: string | null;
  event: LinkInBioEventSummary | null;
};

export type LinkInBioItemEvent = LinkInBioEventSummary & { dateLabel: string | null };

export type LinkInBioItem =
  | { kind: 'heading'; key: string; title: string }
  | {
      kind: 'link';
      key: string;
      title: string;
      href: string;
      imageUrl: string | null;
      icon: string | null;
      style: LinkInBioBlockStyle;
    }
  | {
      kind: 'page';
      key: string;
      title: string;
      href: string;
      pageType: LinkInBioPageType;
      imageUrl: string | null;
      icon: string | null;
      event: LinkInBioItemEvent | null;
      style: LinkInBioBlockStyle;
    }
  | {
      kind: 'portal';
      key: string;
      title: string | null;
      href: string;
      icon: string | null;
      style: LinkInBioBlockStyle;
    }
  | { kind: 'email'; key: string; blockId: string | null; title: string | null };

export type LinkInBioPaths = { pagePrefix: string; portal: string; pageQuery?: string };
